import React from 'react';
import PropTypes from 'prop-types';
import { CardContext } from '../../hoc/withCards';
import TermYearCard from './TermYearCard';
import ListFilter from 'components/common/list-filter/ListFilter';

const TermYearList = ({ renderLoading, onChangeForm }) => {
  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          <ListFilter
            type="text"
            searchInputLabel="Buscar..."
            onValueChange={onChangeForm}
          />
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card) => (
                <TermYearCard key={card.id} id={card.id} termYear={card} />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

TermYearList.propTypes = {
  renderLoading: PropTypes.func.isRequired,
  onChangeForm: PropTypes.func.isRequired,
};

export default TermYearList;
